import * as React from "react";
import { useState, useEffect } from "react";
import { Typography, Card } from "@mui/material";
import { CustomButton } from "../components/CustomButton";
import { styles } from "../theme/styles";

export default function EditarClustersModal({
  open,
  provider, // { nameProvider, idNumber }
  allClusters, // clusters[] completos (de getClusters)
  initialSelected, // string[] clusters actuales del proveedor
  onSave,
  onCancel,
}) {
  const [seleccionados, setSeleccionados] = useState(initialSelected || []);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setSeleccionados(initialSelected || []);
  }, [initialSelected, open]);

  if (!open || !provider) return null;

  const toggleCluster = (name) => {
    setSeleccionados((prev) =>
      prev.includes(name) ? prev.filter((c) => c !== name) : [...prev, name],
    );
  };

  const handleGuardar = async () => {
    setSaving(true);
    try {
      await onSave(provider.idNumber, seleccionados);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 1100,
        backgroundColor: "rgba(58, 58, 58, 0.8)",
      }}>
      <Card className="div-detalle-prov edicion">
        <Typography variant="h5" color="primary" style={styles.textin}>
          Editar clusters
        </Typography>
        <Typography
          variant="body1"
          color="textSecondary"
          sx={{ marginBottom: "1.25rem" }}>
          {provider.name || provider.nameProvider} · ID {provider.idNumber}
        </Typography>

        <div className="cluster-chip-grid edicion">
          {allClusters.map((cluster) => {
            const selected = seleccionados.includes(cluster.name);
            return (
              <div
                key={cluster.name}
                className={`cluster-chip${selected ? " selected" : ""}`}
                onClick={() => toggleCluster(cluster.name)}>
                <span className="chk-square" />
                {cluster.name}
              </div>
            );
          })}
        </div>
        <p style={{ fontSize: "0.85rem", marginTop: "10px", color: "#5B6472" }}>
          {seleccionados.length} seleccionados
        </p>

        <div className="div-adm-btn">
          <CustomButton
            className="btn-add-prov btn-guardar"
            disabled={saving}
            onClick={handleGuardar}>
            {saving ? "Guardando..." : "Guardar cambios"}
          </CustomButton>
          <CustomButton
            className="btn-add-prov btn-cancelar"
            onClick={onCancel}>
            Cancelar
          </CustomButton>
        </div>
      </Card>
    </div>
  );
}
